/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import Notification from './Notification';
import FeatureObject from './FeatureObject';
import NativeImpl from './NativeImpl';
//@import BaseMoserObject (loadtime) // inlined method, superclass
//@import com/ibm/bi/platform/moser/common/notify/Notification (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/FeatureObject (runtime) // new
//@import NativeImpl (runtime) // invokeMethodByReflection

/**
 * Super class MoserObject in the model objects.
 */
export default class MoserObject extends BaseMoserObject{

	_parent = null;

	_listeners = null;

	_recursiveListeners = null;

	_diagnostics = null;



	/**
	 * Gets the parent of this MoserObject
	 * @return {MoserObject} the parent of this MoserObject
	 */
	getParent() {
		return this._parent;
	}

	/**
	 * Set the parent of this MoserObject
	 * @param {MoserObject} parent The parent of this MoserObject
	 */
	setParent(parent) {
		this._parent = parent;
	}

	/**
	 * Adds a listener to the factory for envent notifications.
	 * @param {INotificationListener} listener listener to be added.
	 */
	addListener(listener, recursive) {
		if (!this._listeners) {
			this._listeners = [];
		}
		this._listeners.push(listener);
		if (recursive) {
			if (!this._recursiveListeners) {
				this._recursiveListeners = [];
			}
			this._recursiveListeners.push(listener);
		}
	}

	/**
	 * Removes a listener from the factory.
	 * @param {INotificationListener} listener listener to be removed.
	 */
	removeListener(listener) {
		if (this._listeners) {
			for (var i = 0; (i < this._listeners.length); ++i) {
				if (this._listeners[i] === listener) {
					this._listeners.splice(i, 1);
					break;
				}
			}
		}
		if (this._recursiveListeners) {
			for (var i = 0; (i < this._recursiveListeners.length); ++i) {
				if (this._recursiveListeners[i] === listener) {
					this._recursiveListeners.splice(i, 1);
					break;
				}
			}
		}
	}

	/**
	 * Fires the notifications to the listeners.
	 * @param {Notification} notification notifications to be fired.
	 */
	notify(notification, isChildNotification) {
		if (isChildNotification && (this._recursiveListeners)) {
			for (var __i_enFor0 = 0, __exp_enFor0 = this._recursiveListeners, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var listener = __exp_enFor0[__i_enFor0];
				listener(notification);
			}
		} else {
			if (this._listeners) {
				for (var __i_enFor1 = 0, __exp_enFor1 = this._listeners, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var listener = __exp_enFor1[__i_enFor1];
					listener(notification);
				}
			}
		}
		if (this._parent) {
			this._parent.notify(notification, true);
		}
	}

	_setAndNotify(featureID, oldValue, newValue, isMoserObject, isObjectType) {
		if (isMoserObject) {
			if (newValue != null) {
				(newValue)._parent = this;
			}
		}
		if (isObjectType) {
			MoserObject.updatePropertyOverride((this), this, featureID, false);
		}
		var notification = new Notification(3, this, featureID, oldValue, newValue, -1);
		this.notify(notification, false);
	}

	_removeAtAndNotify(list, position, featureID, isMoserObject) {
		var removed = list[position];
		list.splice(position, 1);
		if (isMoserObject && (removed != null)) {
			(removed)._parent = null;
		}
		var notification = new Notification(2, this, featureID, removed, null, position);
		this.notify(notification, false);
	}

	_addAtAndNotify(list, position, value, featureID, isMoserObject, isObjectType) {
		list.splice(position, 0, value);
		if (isMoserObject && (value != null)) {
			(value)._parent = this;
			if (isObjectType) {
				MoserObject.updatePropertyOverride((value), this, featureID, true);
			}
		}
		var notification = new Notification(1, this, featureID, null, value, position);
		this.notify(notification, false);
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "MoserObject";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		return [];
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add diagnostic data to this module object
	 * @param {Diagnostic} diagnostic the Diagnostic object to add
	 */
	addDiagnostic(diagnostic) {
		if (!this._diagnostics) {
			this._diagnostics = [];
		}
		this._diagnostics.push(diagnostic);
	}

	/**
	 * Get the diagnostics from this module object
	 * @return {Array} a list of diagnostics associated with this name
	 */
	getDiagnostics() {
		if (!this._diagnostics) {
			return [];
		}
		return this._diagnostics;
	}

	/**
	 * Remove the Diagnostic data from this module object
	 */
	clearDiagnostics() {
		this._diagnostics = null;
	}

	/**
	 * Create a FeatureObject object with given attributes
	 * @param {String} featureName The feature name of the object
	 * @param {boolean} isModelledObjList The feature is a List of MoserObject
	 * @param {boolean} isEnum The feature object is an Enum.
	 * @param {Class} type The feature name of the object
	 * @param {boolean} isList The feature object is a List.
	 * @param {int} featureID The feature id of the object
	 * @return {FeatureObject} a FeatureObject for the given attributes
	 */
	createFeature(isList, isEnum, isModelledObjList, featureID, featureName, type) {
		var feature = new FeatureObject();
		feature.setType(type);
		feature.setFeatureID(featureID);
		feature.setIsList(isList);
		feature.setIsEnum(isEnum);
		feature.setIsModelledObjList(isModelledObjList);
		feature.setFeatureName(featureName);
		return feature;
	}

	/**
	 * Get the value of a specific feature ID based on object property.
	 * @param {String} featureName the feature id of the attribute to get
	 */
	getFeatureID(featureName) {
		var featureList = this.getFeatureList(null);
		var featureID = 0;
		for (var i = 0; (i < featureList.length); ++i) {
			var feature = featureList[i];
			if (feature.getFeatureName() == featureName) {
				featureID = feature.getFeatureID();
				break;
			}
		}
		return featureID;
	}

	/**
	 * Get the name of a specific feature ID based on object property.
	 * @param {int} featureID the feature name of the attribute
	 */
	getFeatureName(featureID) {
		var featureList = this.getFeatureList(null);
		var featureName;
		for (var i = 0; (i < featureList.length); ++i) {
			var feature = featureList[i];
			if (feature.getFeatureID() == featureID) {
				featureName = feature.getFeatureName();
				break;
			}
		}
		return featureName;
	}

	/**
	 * Remove the generic data based on the given name
	 */
	removeDiagnostics() {
		this.clearDiagnostics();
		var featureList = this.getFeatureList(null);
		for (var i = 0; (i < featureList.length); ++i) {
			var feature = featureList[i];
			var obj = this.get(feature.getFeatureID());
			if (obj == null) {
				continue;
			}
			if (feature.getIsList()) {
				var fieldList = (obj);
				for (var j = 0; (j < fieldList.length); ++j) {
					var field = fieldList[j];
					if ((field != null) && (field instanceof MoserObject)) {
						var child = (field);
						child.removeDiagnostics();
					}
				}
			} else {
				if (obj instanceof MoserObject) {
					var child = (this.get(feature.getFeatureID()));
					if (child) {
						child.removeDiagnostics();
					}
				}
			}
		}
	}

	/**
	 * Convert <code>MoserObject</code> to <code>JSONObject</code>.
	 * @return {Object} <code>JSONObject</code> for <code>MoserObject</code> object.
	 */
	toJSON() {
		var result = {};
		var featureList = this.getFeatureList(null);
		for (var i = 0; (i < featureList.length); ++i) {
			var feature = featureList[i];
			var featureName = feature.getFeatureName();
			if ("clazz" == featureName) {
				featureName = "class";
			} else {
				if ("dbFunction" == featureName) {
					featureName = "function";
				}
			}
			var obj = this.basicGet(feature.getFeatureID());
			if (obj == null) {
				continue;
			}
			if (feature.getIsList()) {
				var fieldList = (obj);
				if (fieldList.length==0) {
					continue;
				}
				var refArray = [];
				result[featureName] = refArray;
				for (var j = 0; (j < fieldList.length); ++j) {
					var field = fieldList[j];
					if (field != null) {
						if (field instanceof MoserObject) {
							var child = (field);
							refArray.splice(j, 0, child.toJSON());
						} else {
							refArray.splice(j, 0, field);
						}
					}
				}
			} else {
				if (feature.getIsEnum()) {
					var clazz = feature.getType();
					var value = NativeImpl.invokeMethodByReflection(clazz, "value", obj, null, null);
					result[featureName] = value;
				} else {
					if (obj instanceof MoserObject) {
						var child = (obj);
						if (child) {
							result[featureName] = child.toJSON();
						}
					} else {
						if (obj != null) {
							result[featureName] = obj;
						}
					}
				}
			}
		}
		return result;
	}

	/**
	 * Convert <code>MoserObject</code> to <code>String</code>.
	 * @return {String} <code>String</code> for <code>MoserObject</code> object.
	 */
	toString() {
		return this.toJSON().toString();
	}

	/**
	 * A helper method to create a new instance of <code>void</code> object from JSON data.
	 * @param {MoserObject} result <code>MoserObject</> object for storing the result object.
	 * @param {Array} featureList <code>List</> object for the features of the object.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> void</code> object from.
	 */
	static fromJSONHelper(result, featureList, json, factory) {
		var module = MoserObject.getModuleObject(result);
		var oldOverrideModeValue = false;
		if (module) {
			oldOverrideModeValue = module.isOverrideMode();
			module.setOverrideMode(false);
		}
		for (var i = 0; (i < featureList.length); ++i) {
			var feature = featureList[i];
			var featureName = feature.getFeatureName();
			if ("clazz" == featureName) {
				featureName = "class";
			} else {
				if ("dbFunction" == featureName) {
					featureName = "function";
				}
			}
			if (feature.getIsList()) {
				var jsonArray = (json[featureName]);
				if (jsonArray) {
					if (jsonArray.length == 0) {
						result.get(feature.getFeatureID());
					}
					for (var j = 0; (j < jsonArray.length); ++j) {
						var obj = jsonArray[j];
						if (obj != null) {
							if (!(((obj instanceof MoserObject) || ((typeof obj === "string" || obj instanceof String))) || (((typeof obj === "boolean" || obj instanceof Boolean)) || ((typeof obj === "number" || obj instanceof Number))))) {
								var clazz = feature.getType();
								var value = NativeImpl.invokeMethodByReflection(clazz, "fromJSON", null, obj, factory);
								result.addAt(feature.getFeatureID(), j, value);
							} else {
								result.addAt(feature.getFeatureID(), j, obj);
							}
						}
					}
				}
			} else {
				if (feature.getIsEnum()) {
					var enumValue = (json[featureName]);
					if (enumValue != null) {
						var clazz = feature.getType();
						var value = NativeImpl.invokeMethodByReflection(clazz, "fromValue", null, enumValue, null);
						result.set(feature.getFeatureID(), value);
					}
				} else {
					var obj = json[featureName];
					if (obj != null) {
						if (!(((obj instanceof MoserObject) || ((typeof obj === "string" || obj instanceof String))) || (((typeof obj === "boolean" || obj instanceof Boolean)) || ((typeof obj === "number" || obj instanceof Number))))) {
							var clazz = feature.getType();
							var value = NativeImpl.invokeMethodByReflection(clazz, "fromJSON", null, obj, factory);
							result.set(feature.getFeatureID(), value);
						} else {
							result.set(feature.getFeatureID(), obj);
						}
					}
				}
			}
		}
		if (module) {
			module.setOverrideMode(oldOverrideModeValue);
		}
	}

	static getModuleObject(moserObj) {
		if (!moserObj) {
			return null;
		}
		if (moserObj.getObjectType() == "Module") {
			return (moserObj);
		}
		var parent = moserObj.getParent();
		if (parent) {
			return MoserObject.getModuleObject(parent);
		}
		return null;
	}

	static updatePropertyOverride(objType, moserObj, featureID, isAdd) {
		if (featureID == 166) {
			return;
		}
		var module = MoserObject.getModuleObject(objType);
		if (!module) {
			module = MoserObject.getModuleObject(moserObj);
		}
		if ((module) && module.isOverrideMode()) {
			var featureName = moserObj.getFeatureName(featureID);
			if (!isAdd) {
				objType.addPropertyOverride(featureName);
			} else {
				objType.addPropertyOverride("NEW");
			}
		}
	}

	/**
	 * To make a deep copy of <code> MoserObject</code> object.
	 * @return {BaseMoserObject} an instance of <code> MoserObject</code> object
	 */
	clone() {
		var cloned = (super._clone());
		cloned._recursiveListeners = null;
		cloned._parent = null;
		cloned._listeners = null;
		cloned._diagnostics = null;
		if ("Module" == this.getObjectType()) {
			(cloned).setOverrideMode(false);
		}
		var featureList = this.getFeatureList(null);
		for (var i = 0; (i < featureList.length); ++i) {
			var feature = featureList[i];
			var featureName = feature.getFeatureName();
			if ("clazz" == featureName) {
				featureName = "class";
			} else {
				if ("dbFunction" == featureName) {
					featureName = "function";
				}
			}
			var obj = this.basicGet(feature.getFeatureID());
			if (obj == null) {
				continue;
			}
			if (feature.getIsList()) {
				var clonedObj = BaseMoserObject.cloneList((obj));
				cloned._setList(feature.getFeatureID(), clonedObj);
				if (feature.getIsModelledObjList()) {
					var fieldList = (obj);
					var cloneObjList = (clonedObj);
					cloneObjList.length = 0;
					for (var j = 0; (j < fieldList.length); ++j) {
						var field = (fieldList[j]);
						if (field) {
							var clonedField = (field.clone());
							clonedField._parent = cloned;
							cloneObjList.push(clonedField);
						}
					}
				}
			} else {
				if (obj instanceof MoserObject) {
					var clonedObj = (obj).clone();
					cloned.set(feature.getFeatureID(), clonedObj);
				}
			}
		}
		if ("Module" == this.getObjectType()) {
			(cloned).setOverrideMode((this).isOverrideMode());
		}
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/MoserObject.js